import template from './unprocessed-scorecards.hbs'
import Unprocessed from './unprocessed'

const UnprocessedScorecards = Unprocessed.extend({

	template,
	unprocessedDescKey: 'admin.backgroundProcessStatus.percentWeighting.uncalculatedScorecards'

})

export default UnprocessedScorecards

UnprocessedScorecards.__filename__ = 'admin/background-processes/unprocessed-scorecards.js'
